module.exports = __webpack_public_path__ + "img/search.bd34a3ec.svg";